import { useState, useCallback } from 'react';

import { Checkmark, CheckmarkInternalCircle, Container, Label } from './styles';

function SelectBox({ options = [], onChange = () => {} }) {
  const [value, setValue] = useState(null);

  const handleOnChange = useCallback((newValue) => {
    setValue(newValue);
    onChange(newValue);
  }, [onChange]);

  return (
    <Container>
      {options?.map(item => (
        <Label key={item.key} onClick={() => handleOnChange(item.value)}>
          <Checkmark>
            {value === item.value && (
              <CheckmarkInternalCircle />
            )}
          </Checkmark>
          {item?.label}
        </Label>
      ))}
    </Container>
  )
}

export default SelectBox;
